import { createAction } from '@wix/communities-blog-client-common';

export const PAGINATION_LOAD_PAGE = 'pagination/PAGINATION_LOAD_PAGE';
export const PAGINATION_CLEAR_COLLECTION = 'pagination/CLEAR_COLLECTION';

export const paginationLoadPage = createAction(PAGINATION_LOAD_PAGE);
export const paginationClearCollection = createAction(
  PAGINATION_CLEAR_COLLECTION,
);
